/**
 * Instala y registra los componentes
 *
 * @param {Object} components
 * @param {Vue} Vue
 * @param {Object} config
 * @param {Boolean} config.verbose
 * @param {Object} config.package
 */
export const installComponents = (components, Vue, config) => {
  const componentNames = Object.keys(components)

  componentNames.forEach(each => {
    const name = components[each].name || each

    Vue.component(name, components[each])
  })

  if (config.verbose) {
    console.log(`Installed ${config.package.name} components: ${componentNames}`)
  }
}
